import ProductPage from "../../components/ProductPage";
import { npsData } from "../../data/productsData";
export default function NPS() { return <ProductPage data={npsData} />; }